import api from "./axios";
import { Goal, GoalRequest, GoalType } from "../interfaces/Goal";

// O baseURL do axios já inclui /api.
const BASE = "/Goal";

export async function getGoals(type?: GoalType): Promise<Goal[]> {
  const { data } = await api.get(BASE, { params: { type } });
  return Array.isArray(data) ? data : [];
}

export async function createGoal(request: GoalRequest): Promise<Goal> {
  const { data } = await api.post(BASE, request);
  return data;
}

/** Soft-delete: a meta sai da resolução de vigência e a anterior volta a valer. */
export async function deleteGoal(id: number): Promise<void> {
  await api.delete(`${BASE}/${id}`);
}
